import AvatarDropdown from "./AvatarDropdown";

const RightContent = () => {
  return (
    <div className="containerHeader">
      <p className="titleHeader">Comunidade - Entendendo a Adolescência</p>
      <AvatarDropdown/>
    </div>
  );
}

export default RightContent;